var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 5H5.125C3.05406 5 2 6.53906 2 8.4375V11.875H22V8.4375C22 6.53906 20.9459 5 18.875 5Z",
    fill: "#1B75BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.3125C2 17.2109 3.05406 18.75 5.125 18.75H18.875C20.9459 18.75 22 17.2109 22 15.3125V11.875H2V15.3125Z",
    fill: "#F9CB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaFlag);
export default __webpack_public_path__ + "static/media/UA_flag.f311210487c10cb4f20cafa590886990.svg";
export { ForwardRef as ReactComponent };